import { render } from "./rechargeC2C.vue?vue&type=template&id=cc9d10b0&scoped=true"
import script from "./rechargeC2C.vue?vue&type=script&lang=js"
export * from "./rechargeC2C.vue?vue&type=script&lang=js"

import "./rechargeC2C.vue?vue&type=style&index=0&id=cc9d10b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9d10b0"]])

export default __exports__